import FontHeading4 from '../../../../../../../components/fonts/font-heading4/font-heading4';
import { FONT_COLOR, FONT_VARIANT } from '../../../../../../../components/fonts/font-props';

import { ItemEligibilityDto } from '../../order-eligibility-display.service';

import OrderItemCard from './order-item-card';

interface OrderItemsAnalysisProps {
    filteredItems: ItemEligibilityDto[];
    policyFilter: string;
}

const OrderItemsAnalysis: React.FC<OrderItemsAnalysisProps> = ({ 
    filteredItems, 
    policyFilter 
}) => {
    return (
        <div className="order-items-section">
            <FontHeading4 color={FONT_COLOR.PRIMARY1} variant={[FONT_VARIANT.BOLD]}>
                Order Items Analysis
            </FontHeading4>
            <div className="items-grid">
                {filteredItems.map((item, index) => (
                    <OrderItemCard 
                        key={item.line_item_id || index}
                        item={item} 
                        index={index}
                        policyFilter={policyFilter}
                    />
                ))}
            </div>
        </div>
    );
};

export default OrderItemsAnalysis;
